/**
 * Created by yougen on 8/14/15.
 */

    var $ = require('@alife/alpha-jquery/jquery'),
        Base = require('@alife/alpha-base/base'),
        I18N = require('./i18n') || require('./i18n')._('en-us'),
        PopUp = require('@alife/alpha-popup/popup'),
        Validator = require('@alife/alpha-validator/validator.js'),
        Token = require('../common/token'),
        SecurityCode = require('../common/security-code.js'),
        PrivacyCard = require('../common/privacy-card.js'),
        Handlebars = require('@alife/alpha-handlebars/handlebars'),
        Lang = require('../common/lang.js'),
        CookieInfo = require('@alife/alpha-cookie-info/cookie-info.js'),
        InquirySend = require('../common/inquiry-send.js'),
        ExchangeMessage = require('../common/exchange-message'),
        AliTalkRfq = require('@alife/alpha-alitalk/alitalk.js'),
        SecurityUtil = require('../common/security-util.js'),
        preInquiryContentTpl = require('./pre-inquiry-content.tpl'),
        preInquirySuccessTpl = require('./pre-inquiry-result.tpl');

    var STEP = 10, MIN = 1, MAX = 999999;
    var baseUrl = "//message.alibaba.com",
        URLS = {
            COMPANY_INFO: '/msgsend/companyInfo.htm',
            PRODUCT_INFO: '/msgsend/newProductInfo.htm',
            SEND_INQUIRY: '/msgsend/contact.htm?action=ajaxNewSendInquiryAction&iframe_delete=true',
            SUCCESS: '/msgsend/feedbackInquirySucess.htm',
            FAIL: '/msgsend/errorMessage.htm'
        };
    var contentTpl = 'Hi,\r\nI would like to know the price for {{productName}}.\r\nI am interested in buying {{quantity}}.\r\n{{#if moreContent}}{{{moreContent}}}\r\n{{/if}}Please provide us with a quotation.\r\nThank you.';

    Handlebars.registerHelper('I18N4PRE', function(key) {
        if (key) {
            return I18N.app[key] || '';
        }
        return '';
    });
    Handlebars.registerHelper('compare', function (lvalue, operator, rvalue, options) {
        var operators, result;

        if (arguments.length < 3) {
            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
        }

        if (options === undefined) {
            options = rvalue;
            rvalue = operator;
            operator = "===";
        }
        operators = {
            '==': function (l, r) {
                return l == r;
            },
            '===': function (l, r) {
                return l === r;
            },
            '!=': function (l, r) {
                return l != r;
            },
            '!==': function (l, r) {
                return l !== r;
            },
            '<': function (l, r) {
                return l < r;
            },
            '>': function (l, r) {
                return l > r;
            },
            '<=': function (l, r) {
                return l <= r;
            },
            '>=': function (l, r) {
                return l >= r;
            },
            'typeof': function (l, r) {
                return typeof l == r;
            }
        };

        if (!operators[operator]) {
            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
        }

        if (typeof rvalue === 'string' && rvalue.indexOf('||') !== -1) {
            result = false;
            $.each(rvalue.split('||'), function (i, rvalue) {
                result = (result || operators[operator](lvalue, rvalue));
            });
        }
        else if (typeof rvalue === 'string' && rvalue.indexOf('&&') !== -1) {
            result = true;
            $.each(rvalue.split('&&'), function (i, rvalue) {
                result = (result && operators[operator](lvalue, rvalue));
            });
        }
        else {
            result = operators[operator](lvalue, rvalue);
        }

        if (result) {
            return options.fn(this);
        }
        else {
            return options.inverse(this);
        }

    });

    var PreInquiry = Base.extend({
        initialize: function(config){

            PreInquiry.superclass.initialize.call(this,config);

            this.fobPriceContainer = this.get('fobPriceContainer');
            this.productAttrs = this.get('productAttrs');
            // this.isShowATM = this.get('isShowATM');
            // this.isSuccessCurrent = this.get('isSuccessCurrent');
            // 有sidebar说明是放在sidebar部分，不显示ATM，成功页面跳转到当前。
            this.sidebar = config.sidebar || null;

            this.fetchData();
        },
        attrs: {
            parentNode: 'body',
            sourceID: '',// product id
            sourceID_f: '',// 加密id,
            secATMId: '',// webATM 加密ID
            atm_from: '', // webATM来源
            appFrom: 's_en',//语言来源
            sceneId: 'detail',//布点来源, 目前有detail和minisite
            domain: 1,// 1表示对产品发询盘，2表示对公司
            bizType: 7,// 表示表单前置
            popup: 0, //历史遗留
            _host_token_: '',
            _csrf_token_: '',
            umidToken: '',
            usrText: ['Chat Now!', 'Leave Messages', 'I\'m Away', 'I\'m Busy'], // 旺旺文案
            usrTipText: ['Chat with me', 'Please Leave a Message', 'Please Leave a Message', 'Please Leave a Message'], // 旺旺hover文案
            language: "",// 如果指定了语种, 则不受语种切换影响
            mloca: "preposition_other",//询盘发起埋点位置
            startOrderId: ''
        },
        fetchData: function(){
            var inquiryProduct = this.get('domain') == 1,
                id = inquiryProduct ? "productId" : "companyId",
                id_f = inquiryProduct ? "productId_f": "companyId_f",
                secToken,
                tokenKey,// 旺铺使用_host_token_,其余用_csrf_token_
                inquiryData = {},url,self = this;
            // inquiryData[id] = 9639365;
            inquiryData[id] = this.get('sourceID');
            inquiryData[id_f] = this.get('sourceID_f');
            url = this.get('domain') == 1 ? URLS.PRODUCT_INFO: URLS.COMPANY_INFO;
            if(this.get('_csrf_token_')){
                tokenKey = "_csrf_token_";
                secToken = this.get('_csrf_token_');
            }else {
                tokenKey = "_host_token_";
                secToken = this.get('_host_token_');
            }
            inquiryData[tokenKey] = secToken;
            if(this.get('language')){
                url += "?globalFeedbackLanguage=" + this.get('language');
                var lang = Lang(this.get('language'));
                I18N = require('./i18n')._(lang) || I18N;
            }
            this.container = $(this.get('container'));
            this.container.html('<div class="ui-loading"><i class="icon"></i>loading...</div>');
            $.ajax({
                dataType: 'jsonp',
                url: baseUrl + url,
                data: inquiryData,
                success: function(result){
                    self._renderUI(result);
                    self.trigger("Inquiry-Success");
                },
                error: function(){
                    self.trigger("Inquiry-Error");
                },
                timeout:8000
            });
        },
        _renderUI: function(result){
            this.data = result && result.data ? result.data : {};
            if(result && result.data){
                this.data.productAttrs = this.productAttrs;
                this.data.isLogin = CookieInfo.getIsLoggedIn();
                this.data.isProductInquiry = this.get('domain') == 1;
                this.data.defaultQuantityNumber = this.data.moq || 1;
                this.data.minQuantity = (this.data.ladderPrices && this.data.ladderPrices[0] && this.data.ladderPrices[0].minQuantity) || 1;
                this.data.ladderPricesLength = this.data.ladderPrices && this.data.ladderPrices.length;
                if(this.data.ladderPrices) {
                    this.container.addClass('J-has-ladder-price');
                    this.container.parents('.pre-inquiry-property').addClass('J-has-ladder-price');
                    $.each(this.data.ladderPrices, function(index, item) {
                        if(item.maxQuantity == -1) {
                            // －1表示无限大，这里处理下，方便小于阶梯价的选择高亮状态。
                            item.maxQuantity = 10000000;
                        }
                    });
                }
                if(this.data.defaultQuantityNumber >= 10){
                    STEP = 10;
                }else {
                    STEP = 1;
                }
                var startId = this.get('startOrderId');
                startId = startId ? '#' + startId : startId;
                this.data.showNew = !!(startId && $(startId).length);

                this.data.defaultQuantityUnit = this.data.moqunit || 'Piece/Pieces';
                var self = this;
                if(this.data.industryInfo){
                    this.data.industryInfo = $.grep(this.data.industryInfo, function(val){
                        return !!val.valueName;
                    });
                    this.data.industryInfo = $.map(this.data.industryInfo, function(val){
                        if(val.valueName){
                            val.valueName = val.valueName.split(";");
                            if(val.valueName.length > 3){
                                val.valueName = val.valueName.slice(0,3);
                            }
                        }
                        return val;
                    });
                }
                InquirySend.initSecurityData(this.data);
                var formContent = Handlebars.compile(preInquiryContentTpl)(this.data);
                //数据请求完毕, 展示真实数据
                this.container.html(formContent);
                this.form = this.container.find('[data-role=pre-inquiry-form]');
                this.form.attr("action", baseUrl + URLS.SEND_INQUIRY);
                this.toRfq = this.form.find('[data-role=rfq-check]');
                this.toPrivacy = this.form.find('[data-role=to-privacy]');
                this.loginEl = this.form.find('[data-role=from]');
                this.content = this.form.find('[data-role=inq-content]');
                this.quantityNumber = this.form.find("[data-role=quantityNumber]");
                this.quantityUnit = this.form.find("[data-role=quantityUnit]");
                if(startId && $(startId).length) {
                    var el = $(startId);
                    var action = this.form.find("[data-role=inq-startOrder]");
                    action.attr('href', el.attr('href')).attr('data-domdot', el.attr('data-domdot'));
                    this.form.find('[data-role=inq-action]').addClass('inq-action');
                    if(window.localStorage && localStorage.getItem('START_ORDER_POPUP_TIMES') !== '1'){
                        this.form.find('[data-role=startOrder-tip]').show();
                        this.form.parent().css("overflow", "visible");
                    }
                    this.form.find('[data-role=orderTip-close]').on('click', function(){
                        self.form.find('[data-role=startOrder-tip]').remove();
                        self.form.parent().css("overflow", "hidden");
                        if(window.localStorage){
                            localStorage.setItem('START_ORDER_POPUP_TIMES', '1');
                        }
                    });
                }
                if(!!this.data.isProductInquiry && !this.data.ladderPrices){
                    this._initQuantity();
                }
                if(!this.sidebar) {
                    this.renderATM();
                }
                this._bindUI();
                new PrivacyCard({
                    data: this.data,
                    trigger: this.form.find("[data-role=privacy-tip]")
                }).renderCard();
                this.checkCode = new SecurityCode({
                    el: this.form.find("[data-role=check-code-element]")
                });
                this._validate();

                this._fixFobPrice();
            }
        },
        renderATM: function(){
            if(!this.get("secATMId")){
                return;
            }
            this.atm = this.form.find("[data-role=alitalk]");
            this.atm.show();
            var self = this;
            // 新版ATM使用方式
            this.atm.attr('data-uid', this.get('secATMId'));
            this.atm.attr('data-pid', this.get('sourceID'));
            AliTalkRfq.renderList(this.atm, {
                usrText: this.get("usrText"),
                usrTipText: this.get("usrTipText")
            });
            // 打点
            this.atm.on("click", function(){
                if(self.get("sceneId") == 'minisite'){
                    dot(2932, 'ext=from=biz7');
                }else if(self.get("appFrom") == 's_en') {
                    dot(3302, 'ext=from=biz7');
                }else {
                    dot(2038, 'ext=from=biz7');
                }
            });
        },
        _initQuantity: function(){
            var self = this;
            this.quantityUnitPop = new PopUp({
                align: {
                    selfXY: [0, 1]
                },
                trigger: this.form.find("[data-role=unit-trigger]"),
                triggerType: 'click',
                element: this.form.find("[data-role=unit-list]"),
                events: {
                    'click li': function(e){
                        var el = $(e.currentTarget);
                        self.quantityUnit.html(el.text() + '<i class="icon icon-down"></i>');
                        self.quantityUnit.attr("title", el.text());
                        this.hide();
                    }
                }
            });
        },
        _bindUI: function(){
            var self = this;
            this.form.on("keypress",function(event){
                if(event.keyCode == 13 && $(event.target)[0] != self.content[0]) { // enter key
                    event.preventDefault();
                    return false;
                }
            });
            this.quantityInc = this.form.find("[data-role=inq-increase]");
            this.quantityRed = this.form.find("[data-role=inq-reduce]");
            if(this.data.defaultQuantityNumber <=1) {
                this.quantityRed.removeClass("quantity-down-usable");
            }
            if(this.data.minQuantity) {
                this.quantityNumber.val(this.data.minQuantity);
            }
            if(this.data.defaultQuantityNumber) {
                this.quantityNumber.val(this.data.defaultQuantityNumber);
            }
            this.quantityInc.on("click", function(){
                this.changeQuantity(STEP);
            }.bind(this));
            this.quantityRed.on("click", function(){
                this.changeQuantity(-STEP);
            }.bind(this));
            this.content.focusin(function(){
                if(!this.stat){
                    dot(16473);
                    this.stat = true;
                }
                setTimeout(function(){
                    self.content.height(self.content.height()*2);
                }, 500);
            }).focusout(function(){
                setTimeout(function(){
                    self.content.height(self.content.height()/2);
                }, 500);
            });
            //代理自定义sku事件
            this.form.find("[data-role=inq-key]").on("click", "[data-role=sku-remove]", function(){
                $(this).closest("[data-custom=sku-custom]").remove();
            });
            this.form.find("[data-role=inq-key]").on("mouseenter", "[data-custom=sku-custom]", function(){
                $(this).find("[data-role=sku-remove]").addClass('sku-show');
            });
            this.form.find("[data-role=inq-key]").on("mouseleave", "[data-custom=sku-custom]",function(){
                $(this).find("[data-role=sku-remove]").removeClass('sku-show');
            });
            this.form.find("[data-role=inq-prop]").on("click", "li", function(){
                if(!this.stat){
                    dot(16473);
                    this.stat = true;
                }
                $(this).parent("[data-role=inq-prop]").find("li").removeClass("selected");
                $(this).addClass("selected");
                //触发校验
                $(this).parent("[data-role=inq-prop]").trigger("blur");
            });
            var skuError = $('<p class="ui-form-help ui-feedback ui-feedback-addon ui-feedback-error ui-feedback-body" style="display:none">' + I18NUtil("feedback.msgsend.control.sku.limit") + '</p>');
            this.form.find("[data-role=sku-add]").each(function(i, val){
                var inqKeyAddEle = this;
                $(inqKeyAddEle).on("click", function(e){
                    var inqKey = $(inqKeyAddEle).closest("[data-role=inq-key]"),skuAddContainer = inqKey.find(".sku-add-container");
                    if($(this).hasClass("icon-up")){
                        $(inqKeyAddEle).removeClass("icon-up").addClass("quantity-up");
                        skuAddContainer.hide();
                        return;
                    }
                    e.preventDefault();
                    if(skuAddContainer.length == 0){
                        skuAddContainer = $('<div class="sku-add-container">' +
                        '<input class="ui-textfield ui-textfield-system" placeholder="' + I18NUtil("feedback.msgsend.control.fill.requirement") + '">' +
                        '<a href="javascript:;" class="sku-add-confirm" data-role="sku-add-confirm"><i class="icon icon-plus-blue"></i>Add</a>' +
                        '</div>');
                        skuAddContainer.appendTo(inqKey);
                    }
                    skuAddContainer.show();
                    $(inqKeyAddEle).removeClass("quantity-up").addClass("icon-up");
                    var errorTip;
                    // add customer sku
                    skuAddContainer.find("[data-role=sku-add-confirm]").off("click").on("click",function(){
                        if(skuAddContainer.find("input").val() == '' || skuAddContainer.find("input").val().length > 20){
                            if(inqKey.find(".ui-feedback-error").length == 0){
                                errorTip = skuError.clone();
                                inqKey.append(errorTip);
                                errorTip.show();
                            } else {
                                inqKey.find(".ui-feedback-error").remove();
                                errorTip = skuError.clone();
                                inqKey.append(errorTip);
                                errorTip.show();
                            }
                            return;
                        }else {
                            inqKey.find(".ui-feedback-error").remove();
                        }
                        $(inqKeyAddEle).removeClass("icon-up").addClass("quantity-up");
                        skuAddContainer.hide();
                        inqKey.find("[data-role=inq-prop] > li").removeClass("selected").last().remove();
                        // note: need encode
                        var skuValue = skuAddContainer.find("input").val();
                        inqKey.find("[data-role=inq-prop]").prepend('<li data-custom="sku-custom" data-role="attr" class="tag selected" data-attrname="'+ skuValue + '">' +
                        '<a href="javascript:;"><span>'+ SecurityUtil.encodeHTML(skuValue) + '</span><span class="close pre-inquiry-delete" data-role="sku-remove"></span></a></li>');
                        skuAddContainer.find("input").val("");
                    });
                });
            });
            this.changeStepQuote();
            // 打点统计
            if(this.quantityNumber){
                this.quantityNumber.on("change", function(){
                    self.changeStepQuote();
                    dot(16469);
                });
            }
            this.form.on("click", "[data-cmd=check-code-refresh]", function(){
                self._refreshCode();
            });
            this._bindSidebarUI();
        },
        // Sidebar UI Bind.
        _bindSidebarUI: function() {
            var mod = this.sidebar;
            if(mod) {
                mod.setIconHover($('<i class="side-ico-hv-contact"></i>'));
                switch(mod.getSidebarType()){
                    case 'small':
                        mod.setIcon($('<i class="side-ico-hv-sm-contact"></i>'));
                        break;
                    case 'normal':
                        mod.setIcon($('<i class="side-ico-contact"></i>'));
                        break;
                    default:
                        break;
                }

                mod.on('typeChange', function(type){
                    switch(type){
                        case 'small':
                            mod.setIcon($('<i class="side-ico-hv-sm-contact"></i>'));
                            break;
                        case 'normal':
                            mod.setIcon($('<i class="side-ico-contact"></i>'));
                            break;
                        default:
                            break;
                    }
                });
                mod.on('firstPopup', function(){
                    // console.log('first popup');
                });
            }
        },
        _refreshCode: function(){
            if(this.checkCode){
                this.checkCode.refresh();
            }
        },
        _validate:function(){
            var self = this;
            var validator = new Validator({
                element: this.form,
                autoSubmit : false,
                itemSelector: '.ui2-form-control',
                errorParentSelector: '.ui2-form-control'
            });

            function hideMessage(){
                if(self.form.find("[data-role=inq-prop]").length){
                    validator.hideMessage(null, self.form.find("[data-role=inq-prop]"));
                }
                validator.hideMessage(null, self.content);
            }

            var preMsgOrProp = function(options){
                var result = true;
                if(self.content.val() != '' && self.content.val() > 20 && self.content.val() < 8000){
                    hideMessage();
                    result = false;
                }

                self.form.find("[data-role=inq-prop] > li").each(function(index, val){
                    if($(this).hasClass("selected")){
                        result = false;
                        hideMessage();
                        return false; // break each loop
                    }
                });
                return result;
            };
            validator.addItem({
                element: this.content,
                required: preMsgOrProp,
                rule: 'minlength{min:20} maxlength{max:8000}',
                errormessageRequired: I18NUtil('feedback.msgsend.control.msgContent.msg.must'),
                errormessageMinlength: I18NUtil('feedback.msgsend.control.msgContent.msg.char.limit'),
                errormessageMaxlength: I18NUtil('feedback.msgsend.control.msgContent.msg.char.limit')
            });

            if(this.form.find("[data-role=inq-prop]").length > 0){
                validator.addItem({
                    element: this.form.find("[data-role=inq-prop]"),
                    required: preMsgOrProp,
                    errormessage: I18NUtil('feedback.msgsend.control.msgContent.msg.must')
                });
            }

            if(this.data.isProductInquiry){
                validator.addItem({
                    element: this.quantityNumber,
                    rule: 'number min{min:1} max{max:999999}',
                    errormessageMin: I18NUtil('feedback.msgsend.control.msgQuantity.limit.between'),
                    errormessageMax: I18NUtil('feedback.msgsend.control.msgQuantity.limit.between'),
                    errormessageNumber: I18NUtil('feedback.msgsend.control.msgQuantity.limit.number')
                });
            }

            validator.off("formValidated").on('formValidated', function(err, result, elem) {
                if (!err) {
                    this.send();
                }
            }.bind(this));
        },
        changeQuantity: function(step){
            var currentStep = +this.quantityNumber.val();
            if(isNaN(currentStep)) {
                return;
            }
            var val = Number(currentStep + step);
            if(val < MIN || val > MAX) {
                return;
            }
            if(val <= 1) {
                this.quantityRed.removeClass("quantity-down-usable");
            }else {
                this.quantityRed.addClass("quantity-down-usable");
            }
            this.quantityNumber.val(val);
            this.changeStepQuote();
        },
        send: function(){
            dot(16472);
            if(CookieInfo.getIsLoggedIn()){   // 不要用this.data.isLogin
                this.commit();
                return this;
            }
            var loginId = this.loginEl.val();
            if(loginId && loginId == this.data.email) {
                this.commit();
            }else {
                var inquirySend = new InquirySend({
                    loginId: loginId,
                    email: this.data.email,
                    callback: {fn: this.commit, context: this}
                });
                inquirySend.checkEmail({
                    bizScenes: 'pre-inquiry',
                    noalibaba: false
                });
            }
        },
        commit: function(){
            if(this.checkCode.validate()){
                this.setFormData();
                new ExchangeMessage(this.showResult, this, this.form, this.sidebar);
                this.form[0].submit();
            }else {
                this.checkCode.show();
            }
        },
        // 存在极少量情况下出现7001
        showResult: function(data){
            var that = this;
            data.success = (data.code == 200 || data.code == 7001);

            var url,sceneId,memSeq;

            if(this.sidebar) {
                // Sidebar项目需要在当前窗口显示成功页面
                data.success = (data.code == 200 || data.code == 7001);

                data.rfqTarget = getRfqTarget();
                data.rfqTarget += "&productId=" + this.get('sourceID');

                var content = Handlebars.compile(preInquirySuccessTpl)(data);

                this.container.append(content);

                window.setTimeout(function() {
                    that.container.find('.sidebar-contact-supplier-result').remove();
                    that.resetFormData();
                }, 2000);
            } else {
                if(data.code == 200 || data.code == 7001){
                    url = baseUrl + URLS.SUCCESS;
                    sceneId = data.data && data.data.sceneId,
                        memSeq = data.data && data.data.aliMemberId;
                    if(this.get('domain') == 1){
                        url += "?productIds=" + this.get('sourceID');
                    }else {
                        url += "?aliMemberId=" +  memSeq;
                    }

                    url += "&sceneId=" + sceneId;
                    if(data.code == 7001){
                        url += "&code=7001";
                        if(window.dmtrack){
                            dmtrack.dotstat(14769,{},true);
                        }
                    }
                    window.location.href = url;
                } else {
                    var error = data.data && data.data.errorMessage;
                    url = baseUrl + URLS.FAIL  + "?errorMessage=" + error;
                    window.location.href = url;
                }
            }
        },
        setFormData: function(){
            this.form.find("input[data-role=domain]").val(this.get('domain'));
            this.form.find("input[data-role=pageId]").val(window.dmtrack_pageid);
            this.form.find("input[data-role=id]").val(this.get('sourceID'));
            this.form.find("input[data-role=id_f]").val(this.get('sourceID_f'));
            this.form.find("input[data-role=appFrom]").val(this.get('appFrom'));
            this.form.find("input[data-role=bizType]").val(this.get('bizType'));
            this.form.find("input[data-role=popup]").val(this.get('popup'));
            this.form.find("input[data-role=mloca]").val(this.get('mloca'));
            this.form.find("input[data-role=umidToken]").val(this.get('umidToken'));
            var token = Token.getToken();
            if(token){
                this.form.find("input[data-role=ctoken]").val(token);
            }else {
                var refToken = this.get('_host_token_');
                this.form.find("input[data-role=_host_token_]").val(refToken);
            }

            var price = this.form.find('.pre-inquiry-quote-step-selected .pre-inquiry-price').text();
            this.form.find('input[data-role=priceValue]').val((price && price.trim()) || '');
            //form表单默认在checkbox勾选后值为on
            var quantity = '';
            if(this.data.isProductInquiry) {
                this.form.find("input[data-role=toRfq]").val(this.toRfq.prop("checked"));
                quantity = this.quantityNumber.val() + ' ' + this.quantityUnit.text();
                this.form.find("input[data-role=quantityValue]").val(quantity);
            }else {
                this.form.find("input[data-role=toRfq]").val(false);
                this.form.find("input[data-role=quantityValue]").val('');
            }
            this.form.find("input[data-role=sendCard]").val(this.toPrivacy.prop("checked"));
            var content = Handlebars.compile(contentTpl)({
                productName: this.data.productName,
                quantity: quantity,
                moreContent: this.content.val()
            });
            if(this.content.val() == ''){
                dot(16471);
            }
            this.form.find("input[data-role=content]").val(content);
            this.serializeIndustryInfo();
            this.serializeSecCode();
        },
        /**
         * Reset Form Data.
         */
        resetFormData: function() {
            // debugger;
            if(this.form) {
                this.form.get(0).reset();
                this.form.find('.selected').removeClass('selected');
            }

        },
        serializeSecCode: function(){
            var secData = this.checkCode.getPostData();
            for(var key in secData){
                this.form.find("input[data-role=" + key + "]").val(secData[key]);
            }
        },
        serializeIndustryInfo: function(){
            var ret = {};
            this.form.find("[data-role=inq-key]").each(function(){
                var selected = $(this).find("[data-role=attr]").filter(function(){
                    return $(this).hasClass("selected");
                });
                var val = selected.data("attrname");
                if(selected && selected.length == 0){
                    val = '';
                }
                ret[$(this).attr("data-attrId")] = val;
            });

            if($.isEmptyObject(ret)){
                this.form.find("input[data-role=industryInfo]").val('');
            } else {
                this.form.find("input[data-role=industryInfo]").val(JSON.stringify(ret));
            }
        },
        // 根据用户选择的 quantity 范围来改变阶梯报价的状态。
        changeStepQuote: function() {
            var ladderPrices = this.data.ladderPrices || [];
            // @todo 等待后端返回阶梯报价范围.
            var currentQuantity = +this.quantityNumber.val();
            if(isNaN(currentQuantity)) {
                return;
            }
            var shouldStep = (function() {
                var step = 10000; // no selected.

                $.each(ladderPrices, function(index, item) {
                    if(currentQuantity >= item.minQuantity && currentQuantity <= item.maxQuantity) {
                        step = index;
                    }
                });
                return step;
            })();
            this.form.find('[data-role=pre-inquiry-quote-step]').find('.pre-inquiry-quote-step-item').removeClass('pre-inquiry-quote-step-selected');
            this.form.find('[data-role=pre-inquiry-quote-step]').find('.pre-inquiry-quote-step-item').eq(shouldStep).addClass('pre-inquiry-quote-step-selected');

        },

        // 如果有阶梯价, FOB 价格是阶梯报价的最小最大值.
        _fixFobPrice: function() {
            var minPrice, maxPrice, priceUnit, fobPrice;
            if(this.data.ladderPrices) {
                minPrice = (this.data.ladderPrices && this.data.ladderPrices[this.data.ladderPrices.length-1] && this.data.ladderPrices[this.data.ladderPrices.length-1].price) || 0;
                maxPrice = (this.data.ladderPrices && this.data.ladderPrices[0] && this.data.ladderPrices[0].price) || 0;
                priceUnit = this.data.moqunit;
                if(this.fobPriceContainer) {
                    if(this.data.ladderPrices.length == 1) {
                        fobPrice = 'US $' + minPrice + ' ' + priceUnit;
                    } else {
                        fobPrice = 'US $' + minPrice + ' - ' + maxPrice + ' / ' + priceUnit;
                    }
                    $(this.fobPriceContainer).find('[data-role=value]').text(fobPrice);
                }
            }
        }
    });

    // =========== helpers
    function dot(cid, params) {
        if (window['dmtrack']) {
            params = params ? params + '|source=preInq|isNew=true' : 'ext=source=preInq|isNew=true';
            window.dmtrack.dotstat(cid, params);
        }
    }

    function I18NUtil(key){
        return I18N.app[key] || '';
    }

    function htmlDecode(val){
        return String(val).replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/, "'");
    }
    function getRfqTarget() {
        /**
         * th_TH, thai
         * vi_VN vietnamese
         * tr_TR turkish
         * ar_SA arabic
         * en_US english
         */
        var targetHref =
            {   'es_ES': '//us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=spanish&tracelog=es-inquiry-success',
                'pt_PT': '//us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=portuguese&tracelog=pt-inquiry-success',
                'fr_FR': '//us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?french&tracelog=fr-inquiry-success',
                'ru_RU': '//us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=russian&tracelog=ru-inquiry-success  ',
                'ja_JP': '//us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=japanese&tracelog=ja-inquiry-success',
                'de_DE': '//us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=german&tracelog=de-inquiry-success',
                'it_IT': '//us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=italian&tracelog=it-inquiry-success',
                'ko_KR': '//us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=korean&tracelog=ko-inquiry-success',
                'other': '//trends.alibaba.com/product/product_home.htm?unfoldForm=true&tracelog=inquiry_detail_RFQ_201406'
            },
            locale = CookieInfo.getLocale();
        return targetHref[locale] || targetHref["other"];
    }
    module.exports = PreInquiry;
